import React from "react";
import { WHITE } from "@/constants/colors";

import { SpinnerContainer, SpinnerWrapper } from "./Spinner.styled";
import SpinnerIcon from "./SpinnerIcon";

const Spinner = ({ color = WHITE }) => (
  <SpinnerContainer>
    <SpinnerWrapper>
      <SpinnerIcon color={color} />
    </SpinnerWrapper>
  </SpinnerContainer>
);

export default Spinner;
